module.exports = __webpack_public_path__ + "static/img/SearchDetailLogout5.f5f3429.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailLogout5.png
// module id = 741
// module chunks = 0